import { ArrowRightIcon, XCircleIcon } from '@heroicons/react/24/outline';
import { Modal } from '@/components/Modal';
import { OssCard } from './card-data';
import Button from '@/components/Button';

type OssModalProps = Pick<OssCard, 'name' | 'description' | 'link' | 'icon'> & {
  isOpen: boolean;
  onClose: () => void;
};

export function OssModal({ name, description, link, icon, isOpen, onClose }: OssModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} header={<OssModalHeader onClose={onClose} />} variant="dark">
      <div className="bg-[#141415] text-white">
        <div className="grid grid-cols-1 place-items-center pt-6 md:pt-10">
          <div className="flex flex-col items-center pb-8 md:items-start md:pb-14 lg:pb-20 [&>svg]:static [&>svg]:opacity-100">
            {icon}
            <div className="my-6 flex flex-col">
              <h2 className="text-h5">{name}</h2>
            </div>
            <p className="text-body whitespace-pre-line text-gray-4 [&>a]:text-gray-4 [&>a]:underline [&>a]:underline-offset-4 [&>a]:transition-colors hover:[&>a]:text-white">
              {description}
            </p>
            <div className="mt-4 md:mt-6 md:self-end">
              <Button href={link} className="text-body flex items-center gap-2">
                Explore build data <ArrowRightIcon className="size-4" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

function OssModalHeader({ onClose }: { onClose: () => void }) {
  return (
    <div className="mb-4 flex items-center justify-between border-b border-[#2E3135] pb-4 text-white">
      <span className="text-eyebrow-strong">Featured OSS project</span>
      <button className="group" onClick={onClose}>
        <XCircleIcon className="h-10 text-white transition-transform group-hover:rotate-90" />
      </button>
    </div>
  );
}
